import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FrsPackageService } from '../services/frs.package.service';
import { UiService } from '../../../core/services/core.ui.service';
import { ServiceResponseProcessor } from '../../../core/services/core.response-processor.service';
import { PackageModelService } from '../services/frs.package.model.service';

import * as _ from 'lodash';
import { ModalComponent } from '../../../core/config/core.modal-helpers';
@Component({
    selector: 'frs-package-edit',
    template: require('./frs.package.edit.html')
})
export class FrsPackageEditComponent extends ModalComponent implements OnInit {
    @Input() frspackage: any = null;
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

    protected visibilityDropdownData: any = null;
    protected showDeleteConfirmation = false;
    protected formErrors: any = {};

    constructor(
        private frsPackageService: FrsPackageService,
        private uiService: UiService,
        private serviceResponseProcessor: ServiceResponseProcessor,
        protected packageModel: PackageModelService,
    ) { super(); }

    ngOnInit(): void {
        this.packageModel.data = _.clone(this.frspackage);
        this.visibilityDropdownData = this.getDropdownVisibility();
        this.showDeleteConfirmation = false;
        this.packageModel.resetErrors();
    }

    getDropdownVisibility() {
        if (this.packageModel.data.isVisible == 'N') {
            return 'projectadmins';
        }
        if (this.packageModel.data.isPublic == 'N') {
            return 'projectmembers';
        }
        if (this.packageModel.data.requireLogin == 'Y') {
            return 'loggedusers';
        }
        return 'everyone';
    }

    getIsVisible() {
        return this.packageModel.permissionsMatrix[this.visibilityDropdownData].isVisible;
    }

    getRequireLogin() {
        return this.packageModel.permissionsMatrix[this.visibilityDropdownData].requireLogin;
    }

    getIsPublic() {
        return this.packageModel.permissionsMatrix[this.visibilityDropdownData].isPublic;
    }

    setConfigValue(path, value) {
        if (value == undefined || value == _.get(this, path)) return false;
        _.set(this, path, value);
    }

    save() {
        this.formErrors = {};
        this.showDeleteConfirmation = false;
        this.packageModel.data.isVisible = this.getIsVisible();
        this.packageModel.data.requireLogin = this.getRequireLogin();
        this.packageModel.data.isPublic = this.getIsPublic();
        delete this.packageModel.data.releases;
        this.packageModel.data.project = { id: this.packageModel.data.project.id };

        this.frsPackageService.save(
            this.packageModel.data
        ).then((response) => {
            this.uiService.message.showSuccess('Package sucessfully saved.');
            this.close.emit(true);
        }, (response) => {
            this.formErrors = this.serviceResponseProcessor.process(response.error, {}, this.packageModel.errorTypes);
        });
    };

    showDeletePackage() {
        this.showDeleteConfirmation = true;
    };

    deletePackage(frspackage) {

        this.frsPackageService.delete(frspackage.id)
            .then((response) => {
                this.close.emit(true);
                this.uiService.message.showSuccess('Package sucessfully deleted.');
            }, (response) => {
                this.uiService.message.showError("There was an error trying to delete the package");
                this.showDeleteConfirmation = false;
            }
            ).catch((error) => {
                console.log(error);
                this.uiService.message.showError("There was an error trying to delete the package");
                this.showDeleteConfirmation = false;
                throw error;
            });
    };
}
